<template>
  <ContentWrap>
    <el-alert
      class="mb-12px"
      type="info"
      :closable="false"
      title="商城下单积分抵扣 / 赠送规则。与「会员中心 → 会员配置」读写同一份数据（member_config），此处改完两边同步。"
    />
    <el-form
      ref="formRef"
      v-loading="formLoading"
      :model="formData"
      :rules="formRules"
      label-width="140px"
    >
      <el-form-item v-show="false" label="hideId">
        <el-input v-model="formData.id" />
      </el-form-item>

      <el-tabs>
        <el-tab-pane label="积分">
          <el-form-item label="积分抵扣" prop="pointTradeDeductEnable">
            <el-switch v-model="formData.pointTradeDeductEnable" style="user-select: none" />
            <el-text class="w-full" size="small" type="info">
              商城确认订单是否可用积分抵用订单金额
            </el-text>
          </el-form-item>
          <el-form-item label="积分抵扣比例" prop="pointTradeDeductUnitPrice">
            <el-input-number
              v-model="computedPointTradeDeductUnitPrice"
              :precision="2"
              :min="0"
              class="!w-xs"
              placeholder="请输入积分抵扣金额"
            />
            <el-text class="w-full" size="small" type="info">
              1 积分抵多少金额，单位：元
            </el-text>
          </el-form-item>
          <el-form-item label="积分抵扣最大值" prop="pointTradeDeductMaxPrice">
            <el-input-number
              v-model="computedPointTradeDeductMaxPrice"
              :precision="2"
              :min="0"
              class="!w-xs"
              placeholder="请输入单次最多抵扣金额"
            />
            <el-text class="w-full" size="small" type="info">
              单次下单最多抵扣多少金额，单位：元；0 表示不限制。实际扣积分 = 抵扣金额 ÷ 抵扣比例
            </el-text>
          </el-form-item>
          <el-form-item label="1 元赠送多少分" prop="pointTradeGivePoint">
            <el-input-number
              v-model="formData.pointTradeGivePoint"
              :min="0"
              class="!w-xs"
              placeholder="请输入 1 元赠送多少积分"
            />
            <el-text class="w-full" size="small" type="info">
              按实际支付金额赠送积分（实付 1 元赠送多少积分）
            </el-text>
          </el-form-item>
        </el-tab-pane>
      </el-tabs>

      <el-form-item>
        <el-button
          v-hasPermi="['member:config:save']"
          type="primary"
          :loading="formLoading"
          @click="onSubmit"
        >
          保存
        </el-button>
      </el-form-item>
    </el-form>
  </ContentWrap>
</template>

<script lang="ts" setup>
import * as ConfigApi from '@/api/member/config'

/** 商城订单中心入口：与会员配置共用 member_config */
defineOptions({ name: 'MallTradePointConfig' })

const { t } = useI18n()
const message = useMessage()

const formLoading = ref(false)
const formData = ref<ConfigApi.ConfigVO>({
  id: undefined,
  pointTradeDeductEnable: true,
  pointTradeDeductUnitPrice: 0,
  pointTradeDeductMaxPrice: 0,
  pointTradeGivePoint: 0
})

const computedPointTradeDeductUnitPrice = computed({
  get: () => formData.value.pointTradeDeductUnitPrice / 100,
  set: (newValue?: number) => {
    formData.value.pointTradeDeductUnitPrice = Math.round((newValue ?? 0) * 100)
  }
})

/** 最大值按「元」编辑，入库为分（与抵扣比例同一口径） */
const computedPointTradeDeductMaxPrice = computed({
  get: () => (formData.value.pointTradeDeductMaxPrice ?? 0) / 100,
  set: (newValue?: number) => {
    formData.value.pointTradeDeductMaxPrice = Math.round((newValue ?? 0) * 100)
  }
})

const formRules = reactive({})
const formRef = ref()

const onSubmit = async () => {
  if (!formRef.value) return
  const valid = await formRef.value.validate()
  if (!valid) return
  formLoading.value = true
  try {
    await ConfigApi.saveConfig(formData.value)
    message.success(t('common.updateSuccess'))
  } finally {
    formLoading.value = false
  }
}

const getConfig = async () => {
  formLoading.value = true
  try {
    const data = await ConfigApi.getConfig()
    if (data == null) return
    formData.value = data
  } finally {
    formLoading.value = false
  }
}

onMounted(() => {
  getConfig()
})
</script>
